module.exports = __webpack_public_path__ + "img/ranqizao.403fcd42.png";